import { ComponentPropsWithoutRef } from 'react';

export default function PinIconFilled(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10px"
      height="9px"
      viewBox="0 0 10 9"
      version="1.1"
      {...props}
    >
      <g
        id="rfq-/-new"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.600000024"
      >
        <g
          id="rfq-/-2"
          transform="translate(-56.000000, -143.000000)"
          fill="#7FABEC"
        >
          <g id="Group-28" transform="translate(50.000000, 0.000000)">
            <g id="Group-27" transform="translate(0.000000, 96.000000)">
              <g id="Group-25" transform="translate(0.000000, 40.000000)">
                <path
                  d="M14.412825,12.1807049 C14.412825,12.1807049 13.5093005,11.1966846 13.0682163,10.8360962 C12.6263107,10.4746864 12.7068065,9.67137097 12.7068065,9.67137097 L12.7068065,7.70415173 C12.7068065,6.94190562 12.1696201,6.5 11.7433208,6.5 L10.5785956,6.5 L9.4146918,6.5 C8.98839252,6.5 8.45120614,6.94190562 8.45120614,7.70415173 L8.45120614,9.67137097 C8.45120614,9.67137097 8.53170196,10.4746864 8.08979634,10.8360962 C7.64789073,11.1966846 6.74518762,12.1807049 6.74518762,12.1807049 C6.74518762,12.1807049 6.1578967,12.7630675 6.74518762,13.1039427 C7.33165716,13.4456392 9.69560578,13.4653524 9.69560578,13.4653524 L10.5785956,17.5 L11.4624069,13.4653524 C11.4624069,13.4653524 13.8255341,13.4456392 14.412825,13.1039427 C15.0001159,12.7630675 14.412825,12.1807049 14.412825,12.1807049 Z"
                  id="pin-icon"
                  transform="translate(10.579006, 12.000000) rotate(-315.000000) translate(-10.579006, -12.000000) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
